// Shared constants + helpers for the vendor portal pages.
export const MAX_UPLOAD_KB = 5 * 1024; // 5 MB
export const ACCEPT_MIME = ".pdf,.jpg,.jpeg,.png";

export const MULTI_KINDS = [
  { key: "project_certificate", field: "portal_project_certificates", title: "Project Completion Certificates", hint: "Upload one or more certificates for major completed projects." },
  { key: "balance_sheet", field: "portal_balance_sheets", title: "Balance Sheets (last 3 years)", hint: "Upload one per financial year, or a combined PDF." },
];
export const SINGLE_KINDS = [
  { key: "cancelled_cheque", field: "portal_cancelled_cheque", title: "Cancelled Cheque / Bank Details", hint: "Used for empanelment payments." },
  { key: "company_registration", field: "portal_company_registration", title: "Company / MSME Registration", hint: "Registration or MSME certificate." },
];

// Six document sets we track for the completeness meter.
// Order matters for the pending-docs list on the dashboard.
export function docChecklist(reg) {
  reg = reg || {};
  return [
    { key: "pan",        title: "PAN Card Copy",                 done: !!reg.pan_card_url },
    { key: "gst",        title: reg.gst_is_declaration ? "GST · Non-applicability Declaration" : "GST Registration Certificate", done: !!reg.gst_certificate_url },
    { key: "project",    title: "Project Completion Certificate(s)",  done: (reg.portal_project_certificates || []).length > 0 },
    { key: "balance",    title: "Balance Sheets (last 3 years)",      done: (reg.portal_balance_sheets || []).length > 0 },
    { key: "cheque",     title: "Cancelled Cheque / Bank Details",    done: !!(reg.portal_cancelled_cheque || {}).url },
    { key: "companyreg", title: "Company / MSME Registration",        done: !!(reg.portal_company_registration || {}).url },
  ];
}
